// extracted by mini-css-extract-plugin
module.exports = {"banner":"_aa48e0b","mobileButton":"_12d4bf9"};